import React from 'react';

import { FlatList } from 'react-native';

import { useTheme } from 'styled-components/native';

import { AutocompleteItem } from './AutocompleteItem';

import type { AutocompleteType } from './types';

type SuggestionListProps<T> = {
  data: AutocompleteType<T>[];
  onSelect: (item: AutocompleteType<T>) => void;
  highlight?: string;
};

export const SuggestionList = <T,>({ data, onSelect, highlight = '' }: SuggestionListProps<T>) => {
  const theme = useTheme();

  return (
    <FlatList
      data={data}
      keyExtractor={(item) => item.id}
      className="left-0 right-0 rounded-lg border bg-white"
      contentContainerStyle={{
        paddingHorizontal: 16,
        paddingVertical: 8,
      }}
      style={{ borderColor: theme.colors['gray-paragraph'] }}
      renderItem={({ item }) => (
        <AutocompleteItem
          id={item.id}
          placeholder={item.placeholder}
          highlight={highlight}
          onPress={() => onSelect(item)}
        />
      )}
    />
  );
};